import { useHookstate } from "@hookstate/core";
import { AccessData } from "../../types";
import { readerDataStore } from "../../../../hookstate/readerDataStore";

export function useAccessData() {
  const accessData = useHookstate(readerDataStore.accessData).get({
    noproxy: true,
  });

  const setAccessData = (data: AccessData) => {
    readerDataStore.accessData.set(data);
  };

  return { accessData, setAccessData };
}
